<template>
  <div
    :class="[
      'layout--main',
      {
        'layout--main_bg-gray': isGrayBackground,
      },
    ]"
  >
    <a href="#main" ref="skipLink" class="sr-only">{{
      $t('a11y.skipToMainContent')
    }}</a>
    <TheSidebar :sidebarItems="sidebarComputedItems" />
    <transition :name="routerTransition">
      <main
        id="main"
        :class="[
          'content-wrapper',
          {
            'content-wrapper_small': isGrayBackground,
          },
        ]"
        role="main"
        aria-labelledby="page-title"
      >
        <header
          v-if="pageTitle"
          :class="[
            'header',
            {
              'sr-only': isGrayBackground,
              header_sticky: !isGrayBackground,
            },
          ]"
          role="banner"
        >
          <h1 id="page-title">{{ pageTitle }}</h1>
        </header>
        <router-view></router-view>
        <TheFooter />
      </main>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BRANCHES_FETCH } from '@/store/action.types'
import staticSidebarItems from './sidebarItems.js'
import TheSidebar from '@/components/TheSidebar/TheSidebar.vue'
import TheFooter from '@/components/TheFooter.vue'
import { loadSupportCenter } from '@skbkontur/support-center'
import { TP_WIDGET_URL } from '../../common/config.js'

export default {
  components: {
    TheSidebar,
    TheFooter
  },
  data() {
    return {
      routerTransition: 'none',
      sidebarItems: staticSidebarItems
    }
  },
  watch: {
    $route() {
      this.$refs.skipLink.focus()
    }
  },
  computed: {
    ...mapGetters([
      'currentRoles',
      'companyBranches',
      'currentSidebarItems',
      'currentUser'
    ]),
    isGrayBackground() {
      return this.$route.meta.isGrayBackground
    },
    pageTitle() {
      return this.$t(this.$route.meta.title_i18n)
    },
    sidebarComputedItems() {
      return [...this.currentSidebarItems, ...this.sidebarItems]
    }
  },
  methods: {
    async initSupportCenterWidget() {
      const { SupportCenterConstructor, error } = await loadSupportCenter(
        TP_WIDGET_URL
      )
      const envSupportCenterWidget =
        process.env.VUE_APP_ENV === 'production' ? 'production' : 'staging'

      if (!SupportCenterConstructor) {
        error('Не удалось скачать виджет')
      }

      const parameters = {
        integrationId: 'tips', // KE-web, cabinet, diadoc и др.
        type: 'dom',
        environment: envSupportCenterWidget, // staging - стабильная тестовая площадка, production - боевая
        additionalParameters: {
          'base/inn': this.currentUser.inn,
          'base/login': this.currentUser.username
        }
      }

      const supportCenter = new SupportCenterConstructor(parameters)

      const response = await supportCenter.initialize()
      if (response.code !== 'ok') {
        error(response.context.message)
      }
    }
  },
  mounted() {
    this.$km_track('Service', 'Enter', 'Account')
    this.initSupportCenterWidget()

    if (this.$acl.get.includes('company')) {
      if (this.companyBranches.length === 0) {
        this.$store.dispatch(BRANCHES_FETCH)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuesax/_variables';

.layout--main {
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: stretch;

  &_bg-gray {
    background-color: $sidebar-bg-color;
  }

  @media only screen and (max-width: $sidebar-visibility-breakpoint) {
    flex-direction: column;
    min-height: calc(100% - #{$size-7});
  }
}

.content-wrapper {
  min-height: 100%;
  max-width: $content-aria-width;
  width: 100%;
  padding: $size-3 $size-4;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
  z-index: 1;

  &_small {
    padding: $size-3;
  }
}

.header {
  &_sticky {
    position: sticky;
    top: $size-3;
    z-index: 10;
    background: $white;
    box-shadow: 0 -#{$size-3} 0 $size-3 $white;

    @media only screen and (max-width: $sidebar-visibility-breakpoint) {
      position: static;
    }
  }
}
</style>
